import { configureStore } from '@reduxjs/toolkit';
import domainReducer from '../reducer/domainSlice';
import domainMiddleware from '../../middleware/domainMiddleware';
import loadingReducer from '../reducer/loadingReducer';
import partnerConfigReducer from '../reducer/partnerConfig';
import partnerSmsConfigReducer from '../reducer/partnerSmsConfig';

const store = configureStore({
  reducer: {
    domainReducer: domainReducer,
    loadingReducer: loadingReducer,
    partnerConfig: partnerConfigReducer,
    partnerSmsConfig: partnerSmsConfigReducer
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat(domainMiddleware),
});

export default store;
